<template>
  <div class="header-box">
    <div class="header-left">
    </div>
    <div class="header-right">
      <div class="select"
           v-show="$route.name=='detail'">
        <el-select v-model="selectedType"
                   size="small"
                   slot="prepend"
                   style="width:110px"
                   class="typeSearch"
                   :placeholder="$t('topHead.select_option_brand_holder')">
          <el-option v-for="item in searchOptions"
                     :key="item.value"
                     :label="item.name"
                     :value="item.value">
          </el-option>
        </el-select>

        <el-input :placeholder="$t('topHead.select_option_postKeyWords_holder')"
                  style="width:320px"
                  v-model="keyWords"
                  size="small">
          <el-button slot="append"
                     @click="searchKeyWords"
                     icon="el-icon-search"></el-button>
        </el-input>

      </div>
      <div class="myAtention"
           v-show="false">
        <i class="iconfont icon-heart"
           style="color:#FF7875 ;margin-right:12px"></i>
        <span class="headText">{{$t('topHead.my_attention')}}</span>
      </div>
      <userinfo @userLogin="userLoginValue"> </userinfo>

      <div class="language">
        <span @click="changeLanguge('zh')"
              :class="{'selected': localS.getItem('language')=='zh'}">{{$t('topHead.Chinese')}}</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="changeLanguge('en')"
              :class="{'selected': localS.getItem('language')=='en'}">{{$t('topHead.English')}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import { getBrands } from '@/api/search'
import { userinfo } from 'common'
import { parseTime, handelBrandNameOptions, getObjFromUrl } from '@/utils'
const localS = localStorage
export default {
  components: {
    userinfo,
  },
  data() {
    return {
      defaultCheckedKeys: [this.$store.state.user.catId],
      selectIds: [this.$store.state.user.catId],
      localS,
      searchOptions: [
        {
          name: this.$t('topHead.select_option_postKeyWords'),
          value: 'keywords',
        },
        { name: this.$t('topHead.select_option_customer'), value: 'customer' },
        { name: this.$t('topHead.select_option_seller'), value: 'seller' },
        { name: this.$t('topHead.select_option_company'), value: 'company' },
        {
          name: this.$t('topHead.select_option_work_order'),
          value: 'issue',
        },
        { name: this.$t('topHead.select_option_phone'), value: 'phone' },
      ],
      titleWord: '',
      keyWords: this.$store.state.user.selectedKeyWords,
      selectedType: this.$store.state.user.selectedType || 'keywords',
      param_val: getObjFromUrl(window.location.href),
    }
  },
  methods: {
    userLoginValue(val) {
      this.loginInfo = val
      this.$store.dispatch(
        'user/changePostDownload',
        this.loginInfo.post_download ? this.loginInfo.post_download : false
      )
      this.$store.dispatch('user/changeLoginInfo', val)
    },
    mulltipSelectRemoveTag() {},
    clearSelect() {
      this.selectIds = []
    },
    handleRemove(key) {},
    searchKeyWords() {
      if (!this.selectedType) {
        this.$message.warning('请选择类型')
        return
      }
      if (this.selectedType == 'issue') {
        this.$store.dispatch('user/changePmId', this.keyWords.trim())
      }
      this.$store.dispatch('user/changeSelectedType', this.selectedType)
      this.$store.dispatch('user/changeselectedKeyWords', this.keyWords.trim())
      if (
        this.$store.state.user.cf_selected_type &&
        this.$store.state.user.cf_selected_type.length > 0
      ) {
        let cf_selected_type = _.cloneDeep(
          this.$store.state.user.cf_selected_type
        )
        let cf_word = _.cloneDeep(this.$store.state.user.cf_word)
        let index = cf_selected_type.findIndex((item) => {
          return item == this.selectedType
        })
        if (index > -1) {
          cf_word[index] = this.keyWords.trim()
        } else {
          cf_selected_type.push(this.selectedType)
          cf_word.push(this.keyWords.trim())
        }
        this.$store.dispatch('user/changeCfSelectedType', cf_selected_type)
        this.$store.dispatch('user/changeCfWord', cf_word)
      } else {
        this.$store.dispatch('user/changeCfSelectedType', [this.selectedType])
        this.$store.dispatch('user/changeCfWord', [this.keyWords.trim()])
      }
    },
    changeLoginState(val) {},
    //切换语言
    changeLanguge(lan) {
      // this.$i18n.locale = lan
      localStorage.setItem('language', lan)
      location.reload()
    },
  },
  watch: {
    '$store.state.user.selectedKeyWords': {
      handler(newVal, oldVal) {
        this.keyWords = newVal
      },
    },
    '$store.state.user.selectedType': {
      handler(newVal, oldVal) {
        this.selectedType = newVal ? newVal : 'keywords'
      },
      immediate: true,
    },
  },
  created() {
    //this.getBrands(this.$store.state.user.selectedType)
  },
}
</script>

<style>
</style>
